import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';

import { AutocompleteField } from 'components/fields';
import { useFetch, useAuthenticated } from 'hooks/fetch';

const inputHeight = 38;

const styles = theme => ({
  inputContainer: {
    marginRight: 17,
    borderRadius: 16,
    backgroundColor: theme.palette.background.white,
    minHeight: inputHeight,
    width: 300,
    paddingRight: 10,
  },
  inputContainerBig: {
    marginRight: 17,
    borderRadius: 16,
    width: 399,
    minHeight: inputHeight,
    backgroundColor: theme.palette.background.white,
  },
  placeholder: {
    fontWeight: 600,
    color: theme.palette.gray.gray_5,
    opacity: 1,
    fontSize: 14,
    paddingLeft: 18,
  },
  input: {
    paddingLeft: 20,
    height: inputHeight,
  },
  inputRoot: {
    marginTop: '0px !important',
  },
  inputLabel: {
    paddingLeft: 20,
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.gray.gray_5,
    marginTop: -12,
  },
  shrink: {
    fontSize: 17,
    marginTop: -17,
  },
});

const FilterAutoComplete = (props) => {
  const {
    classes,
    name,
    isLoading,
    setIsLoading,
    fields,
    label,
    path,
    getOptionLabel,
    noOptionsMessage,
    loadingMessage,
    onChange,
    whenIsLoading,
    filterHandler,
    placeholder,
    showPlaceholder,
    hideLabel,
    additionalStartPath,
    ...rest
  } = props;

  const selectedValue = props.value;
  const [options, setOptions] = useState(() =>
    selectedValue && selectedValue._id ? [selectedValue] : []
  );
  const [optionsReady, setOptionsReady] = useState(false);
  const [fetchUrl, setFetchUrl] = useState(`${path}${additionalStartPath ? additionalStartPath : ''}`);

  // Load data
  const { data } = useAuthenticated(useFetch, fetchUrl, {
    afterFetch() {
      setIsLoading({ ...isLoading, [name]: false });
    },
  });

  // Keep a pre-selected value visible even when it is not in the first page of options
  useEffect(() => {
    let next = [];
    if (Array.isArray(data)) {
      next = data;
    } else {
      next = (data && data.data) || [];
    }
    if (selectedValue && selectedValue._id) {
      const alreadyListed = next.some(
        item => item && String(item._id) === String(selectedValue._id)
      );
      if (!alreadyListed) {
        next = [selectedValue, ...next];
      }
    }
    setOptions(next);
    if (data !== undefined && data !== false) {
      setOptionsReady(true);
    }
  }, [data, selectedValue]);

  // detects when someone set me to isLoading=true
  useEffect(() => {
    if (isLoading[name]) {
      whenIsLoading({ ...props, fetchUrl, setFetchUrl });
    }
  }, [isLoading[name]]);

  return (
    <AutocompleteField
      {...rest}
      label={!hideLabel && label}
      placeholder={(showPlaceholder && placeholder) || ''}
      name={name}
      options={options}
      isLoading={isLoading[name]}
      getOptionLabel={opt => getOptionLabel(opt)}
      getOptionValue={opt => (opt && opt._id != null ? String(opt._id) : '')}
      onChange={(opt) => {
        // react-select emits null while options are still loading; do not
        // wipe a value that already exists in the shared report context.
        if (!opt && selectedValue && !optionsReady) {
          return;
        }
        onChange({ ...props, opt });
      }}
      innerRef={fields[name]}
      noOptionsMessage={() => noOptionsMessage}
      loadingMessage={() => loadingMessage}
      isClearable={true}
      menuContainerStyle={{
        ...props.menuContainerStyle,
        zIndex: 999,
      }}
      disableUnderline={true}
      fullWidth={false}
      classes={{ placeholder: classes.placeholder }}
      InputProps={{
        ...props.inputProps,
        disableUnderline: true,
        className: classes.input,
        classes: {
          root: classes.inputRoot,
          // input: classes.input,
        },
      }}
      InputLabelProps={{
        className: classes.inputLabel,
        classes: {
          shrink: classes.shrink,
        },
      }}
      InputContainerClass={classes.inputContainer}
      value={props.value || undefined}
    />
  );
};

export default withRouter(withStyles(styles)(FilterAutoComplete));
